import * as types from "../action/ActionType";
import { TYPE_LIST_INITIAL } from "../store/InitialStore";
export default function AllTypeReducer(state = TYPE_LIST_INITIAL, action) {
  const { type, payload } = action;
  switch (type) {
    case types.TYPE_LIST_IN_FILTER:
      return (state = payload);
    default:
      return state;
  }
}
